module.exports = __webpack_public_path__ + "images/product-badges/product-badge-rise-c7e99ae7f48a5683debf429db436d295.webp";